<template lang="html">
    <div class="ps-site-features pb-3 mt-7">
        <div class="ps-container ">
            <div class="ps-block--site-features card-layout">
                <div class="ps-block__item">
                    <div class="ps-block__left">
                        <i class="icon-rocket"></i>
                    </div>
                    <div class="ps-block__right">
                        <h4>
                         Free Delivery 3
                        </h4>
                        <p>
                            For all orders above  ₹5000
                        </p>
                    </div>
                </div>
                <!-- <div class="ps-block__item">
                    <div class="ps-block__left">
                        <i class="icon-sync"></i>
                    </div>
                    <div class="ps-block__right">
                        <h4>
                        </h4>
                        <p></p>
                    </div>
                </div> -->
                <div class="ps-block__item">
                    <div class="ps-block__left">
                        <i class="icon-credit-card"></i>
                    </div>
                    <div class="ps-block__right">
                        <h4>
                            Secure Payment
                        </h4>
                        <p>
                          100% secure payment
                        </p>
                    </div>
                </div>
                <div class="ps-block__item">
                    <div class="ps-block__left">
                        <i class="icon-bubbles"></i>
                    </div>
                    <div class="ps-block__right">
                        <h4>
                       24/7 Support
                        </h4>
                        <p>
                           Dedicated support
                        </p>
                    </div>
                </div>
                <div class="ps-block__item">
                    <div class="ps-block__left">
                        <i class="icon-gift"></i>
                    </div>
                    <div class="ps-block__right">
                        <h4>
                            Exclusive offers
                        </h4>
                        <p>
                          On Top Brands
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SiteFeauturesFullwidth'
};
</script>

<style lang="scss" scoped></style>
